<template>
  <v-card tile v-if="employee !== null">
    <v-card-title>
      <v-row>
        <v-col
            cols="12"
            class="d-flex justify-space-between"
        >
          <span>Zaposleni</span>
          <v-btn icon @click="editable = true" v-if="editable === false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon @click="save" v-else>
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-form :readonly="!editable">
            <h1>
              <v-text-field
                  label="Ime"
                  v-model="employee.first_name"
              ></v-text-field>
              <v-text-field
                  label="Priimek"
                  v-model="employee.last_name"
              ></v-text-field>
            </h1>
            <v-textarea
                label="Stalni naslov"
                v-model="employee.permanent_address"
                outlined
            ></v-textarea>
            <v-menu
                v-model="datepickerMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
                :disabled="editable === false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="employee.birth_date"
                    label="Datum rojstva"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="employee.birth_date"
                  @input="datepickerMenu = false"
              ></v-date-picker>
            </v-menu>

            <v-textarea
                label="Kraj rojstva"
                v-model="employee.birth_place"
                outlined
            ></v-textarea>
            <v-checkbox
                v-model="employee.permanent_residency"
                dense
                label="Rezident"
            ></v-checkbox>
            <v-checkbox
                v-model="employee.permanent_visa"
                dense
                label="Stalna viza"
            ></v-checkbox>
            <v-textarea
                label="Začasni naslov"
                v-model="employee.temporary_address"
                outlined
            ></v-textarea>
            <v-text-field label="Emšo" v-model="employee.nin"></v-text-field>
            <v-text-field
                label="Davčna številka"
                v-model="employee.tax_number"
            ></v-text-field>
            <v-text-field
                label="Številka zavarovanja"
                v-model="employee.health_card_number"
            ></v-text-field>
            <v-text-field
                label="E-poštni naslov"
                v-model="employee.email"
            ></v-text-field>
            <v-text-field
                label="Telefonska številka"
                v-model="employee.phone_number"
            ></v-text-field>
            <v-textarea
                label="Izobrazba"
                v-model="employee.education"
                outlined
            ></v-textarea>
            <v-textarea
                label="Banka"
                v-model="employee.bank"
                outlined
            ></v-textarea>
            <v-text-field label="Iban" v-model="employee.iban"></v-text-field>
            <v-text-field
                label="Številka oblačil"
                v-model="employee.clothes_size"
            ></v-text-field>
            <v-textarea
                label="Zapiski"
                v-model="employee.notes"
                outlined
            ></v-textarea>
            <v-autocomplete
                v-model="employee.company_id"
                :items="companies"
                :search-input.sync="companySearch"
                cache-items
                item-text="title"
                item-value="id"
                label="Podjetje"
            ></v-autocomplete>
            <v-autocomplete
                v-model="employee.employee_status_id"
                :items="statuses"
                :search-input.sync="statusSearch"
                @click="loadEmployeeStatuses"
                item-text="name"
                item-value="id"
                label="Status"
            ></v-autocomplete>
            <v-autocomplete
                v-model="employee.employee_work_type_id"
                :items="workTypes"
                :search-input.sync="workTypeSearch"
                @click="loadEmployeeWorkTypes"
                item-text="name"
                item-value="id"
                label="Tip dela"
            ></v-autocomplete>
            <v-autocomplete
                v-model="employee.insurance_id"
                :items="insurances"
                :search-input.sync="insuranceSearch"
                @click="loadInsurances"
                item-text="name"
                item-value="id"
                label="Zavarovanje"
            ></v-autocomplete>
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data: () => ({
    employee: null,
    editable: false,
    companies: [],
    companySearch: "",
    statuses: [],
    statusSearch: "",
    workTypes: [],
    workTypeSearch: "",
    insurances: [],
    insuranceSearch: "",
    datepickerMenu: null
  }),
  mounted() {
    this.loadEmployee();
  },
  methods: {
    loadEmployee() {
      this.$http
          .get("api/v1/employees/" + this.$route.params.id)
          .then((response) => {
            this.employee = response.data;
            if (response.data.company_id !== null) {
              this.companies.push(response.data.company);
            }
            if (response.data.employee_status_id !== null) {
              this.statuses.push(response.data.employee_status);
            }
            if (response.data.employee_work_type_id !== null) {
              this.workTypes.push(response.data.employee_work_type);
            }
            if (response.data.insurance_id !== null) {
              this.insurances.push(response.data.insurance);
            }
          });
    },
    loadCompanies() {
      if (this.editable === false) {
        return;
      }
      this.$http
          .get("api/v1/companies", {
            params: {
              filters: {title: encodeURI("%" + this.companySearch + "%")},
            },
          })
          .then((response) => {
            this.companies = response.data.data;
          });
    },
    loadEmployeeStatuses() {
      if (this.editable === false || this.statuses.length > 1) {
        return;
      }
      this.$http.get("api/v1/employee-statuses").then((response) => {
        this.statuses = response.data;
      });
    },
    loadEmployeeWorkTypes() {
      if (this.editable === false || this.workTypes.length > 1) {
        return;
      }
      this.$http.get("api/v1/employee-work-types").then((response) => {
        this.workTypes = response.data;
      });
    },
    loadInsurances() {
      if (this.editable === false || this.insurances.length > 1) {
        return;
      }
      this.$http.get("api/v1/insurances").then((response) => {
        this.insurances = response.data;
      });
    },
    save() {
      this.$http
          .put("api/v1/employees/" + this.$route.params.id, this.employee)
          .then((response) => {
            this.employee = response.data;
            this.editable = false;
          });
    },
  },
  watch: {
    companySearch() {
      this.loadCompanies();
    },
  },
};
</script>
<style></style>
